import { useState } from "react";
import { Link } from "react-router-dom";
import { BellRing, Menu, X } from "lucide-react";
import { BRAND } from "@/constants/compliance";

const LINKS = [
  { label: "Manifesto", href: "#manifesto", testId: "nav-link-manifesto" },
  { label: "SMS Opt-in", href: "#optin", testId: "nav-link-optin" },
  { label: "FAQ", href: "#faq", testId: "nav-link-faq" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-[#FAF8F5]/85 border-b border-stone-200/60"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2.5 group"
        >
          <span className="w-9 h-9 rounded-full bg-[#D96B43] text-[#FAF8F5] flex items-center justify-center transition-transform duration-300 group-hover:rotate-12">
            <BellRing size={17} strokeWidth={2.4} />
          </span>
          <span className="font-display font-800 font-extrabold text-lg tracking-tight text-[#1E2022]">
            RemindMe <span className="text-[#D96B43]">&</span> Do
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={l.testId}
              onClick={() => scrollTo(l.href)}
              className="text-sm font-medium text-[#575B60] hover:text-[#1E2022] transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
          <Link
            to="/terms"
            data-testid="nav-link-terms"
            className="text-sm font-medium text-[#575B60] hover:text-[#1E2022] transition-colors duration-200"
          >
            Terms
          </Link>
          <Link
            to="/privacy"
            data-testid="nav-link-privacy"
            className="text-sm font-medium text-[#575B60] hover:text-[#1E2022] transition-colors duration-200"
          >
            Privacy
          </Link>
          <a
            href="https://app.minemeanddo.com"
            data-testid="nav-link-app"
            className="text-sm font-medium text-[#4A7C59] hover:text-[#1E2022] transition-colors duration-200"
          >
            Dashboard
          </a>
          <button
            data-testid="nav-cta-start"
            onClick={() => scrollTo("#optin")}
            className="font-display font-bold text-sm bg-[#1E2022] text-[#FAF8F5] rounded-full px-5 py-2.5 hover:bg-[#D96B43] transition-colors duration-300"
          >
            Text {BRAND.keyword}
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#1E2022]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-stone-200/60 bg-[#FAF8F5]/95 backdrop-blur-md px-5 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`${l.testId}-mobile`}
              onClick={() => scrollTo(l.href)}
              className="text-left text-base font-medium text-[#1E2022]"
            >
              {l.label}
            </button>
          ))}
          <Link to="/terms" data-testid="nav-link-terms-mobile" className="text-base font-medium text-[#1E2022]" onClick={() => setOpen(false)}>
            Terms
          </Link>
          <Link to="/privacy" data-testid="nav-link-privacy-mobile" className="text-base font-medium text-[#1E2022]" onClick={() => setOpen(false)}>
            Privacy
          </Link>
          <a href="https://app.minemeanddo.com" data-testid="nav-link-app-mobile" className="text-base font-medium text-[#4A7C59]" onClick={() => setOpen(false)}>
            Dashboard
          </a>
        </div>
      )}
    </header>
  );
};
